import React from 'react'
import PropTypes from 'prop-types'
import { collapsibleClick } from '@cred/react-analytics/events'
import Collapse from '@kunukn/react-collapse'
import Font from '@cred/react-font'
import styles from './styles.scss'

const TileCollapseSection = ({ marketingBullets, trackSnowplowEvent, onToggleDetails, isDetailsOpen, slug }) => {
  const collapseSectionText = isDetailsOpen ? 'Collapse Card Details' : 'Show Card Details'

  return (
    <div>
      <Collapse className={styles.dropdown} isOpen={isDetailsOpen}>
        <div className="mt-8 mb-8">
          <ul>
            {marketingBullets
              ? marketingBullets.map(({ bullet, uuid }) => (
                <Font
                  type="disclaimer"
                  color="neutral"
                  element="li"
                  key={uuid}
                  className="mb-8"
                  dangerouslySetInnerHTML={{ __html: bullet }}
                />
              ))
              : ''}
          </ul>
        </div>
      </Collapse>
      <div
        className={styles.showDetailsSection}
        onClick={() => {
          trackSnowplowEvent(collapsibleClick, {
            text: collapseSectionText,
            action: isDetailsOpen ? 'collapse' : 'expand',
          })

          onToggleDetails(slug)
        }}
      >
        <Font type="disclaimer" weight="semiBold" color="accent" className="mt-8 align-center">
          {collapseSectionText}{' '}
          <i
            className={`cred-icon ${isDetailsOpen ? 'icon-chevron-up' : 'icon-chevron-down'}`}
          />
        </Font>
      </div>
    </div>
  )
}

TileCollapseSection.propTypes = {
  slug: PropTypes.string.isRequired,
  marketingBullets: PropTypes.array.isRequired,
  onToggleDetails: PropTypes.func.isRequired,
  isDetailsOpen: PropTypes.bool,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

export { TileCollapseSection }

export default TileCollapseSection
